// Fake data generator for testing

export const generateFakeAppointments = (statuses = ['pending', 'assigned', 'accepted', 'rejected', 'serviced', 'reviewed', 'completed']) => {
    const now = new Date();
    const appointments = [];
    const services = ['Personal Care', 'Meal Preparation', 'Medication Reminder', 'Companionship', 'Transportation'];
    
    // Generate appointments for the last 30 days and next 30 days
    for (let i = 0; i < 50; i++) {
        const daysOffset = Math.floor(Math.random() * 60) - 30; // -30 to +30 days
        const appointmentDate = new Date(now);
        appointmentDate.setDate(now.getDate() + daysOffset);
        
        const hour = 9 + Math.floor(Math.random() * 8); // Between 9 AM and 5 PM
        const minute = Math.random() < 0.5 ? 0 : 30; // Either :00 or :30
        const startTime = new Date(appointmentDate);
        startTime.setHours(hour, minute, 0, 0);
        
        const endTime = new Date(startTime);
        endTime.setHours(startTime.getHours() + Math.floor(Math.random() * 3) + 1); // 1-3 hours duration
        
        const pswIndex = Math.floor(Math.random() * 5);
        const patientIndex = Math.floor(Math.random() * 8);
        
        appointments.push({
            appointment_id: `fake-apt-${i + 1}`,
            id: `fake-apt-${i + 1}`,
            start_date: startTime.toISOString(),
            end_date: endTime.toISOString(),
            psw_id: `psw-${pswIndex + 1}`,
            patient_id: `patient-${patientIndex + 1}`,
            service: services[Math.floor(Math.random() * services.length)],
            status: statuses[Math.floor(Math.random() * statuses.length)],
            description: `Appointment for ${services[Math.floor(Math.random() * services.length)].toLowerCase()} services.`
        });
    }
    
    return appointments;
};

export const generateFakeServiceWorkers = () => {
    const firstNames = ['Sarah', 'Michael', 'Emily', 'David', 'Lisa'];
    const lastNames = ['Johnson', 'Chen', 'Rodriguez', 'Kim', 'Thompson'];
    const emails = ['sarah.j', 'michael.c', 'emily.r', 'david.k', 'lisa.t'];
    const serviceWorkers = [];
    
    for (let i = 0; i < 5; i++) {
        const userId = `psw-${i + 1}`;
        serviceWorkers.push({
            user_id: userId,
            psw_id: userId,
            id: userId,
            username: `psw${i + 1}`,
            first_name: firstNames[i],
            last_name: lastNames[i],
            name: `${firstNames[i]} ${lastNames[i]}`,
            email: `${emails[i]}@healthcare.com`,
            phone_number: `(555) ${String(100 + i).padStart(3, '0')}-${String(2000 + i * 100).padStart(4, '0')}`,
            role: 'psw',
            is_active: true
        });
    }
    
    return serviceWorkers;
};

export const generateFakeUsers = () => {
    const firstNames = ['John', 'Mary', 'Robert', 'Patricia', 'Michael', 'Jennifer', 'William', 'Linda'];
    const lastNames = ['Brown', 'Davis', 'Miller', 'Wilson', 'Moore', 'Taylor', 'Anderson', 'Thomas'];
    const emails = ['john.b', 'mary.d', 'robert.m', 'patricia.w', 'michael.m', 'jennifer.t', 'william.a', 'linda.t'];
    const users = [];
    
    for (let i = 0; i < 8; i++) {
        users.push({
            patient_id: `patient-${i + 1}`,
            id: `patient-${i + 1}`,
            first_name: firstNames[i],
            last_name: lastNames[i],
            name: `${firstNames[i]} ${lastNames[i]}`,
            email: `${emails[i]}@email.com`,
            phone_number: `(555) ${String(500 + i).padStart(3, '0')}-${String(3000 + i * 100).padStart(4, '0')}`,
            date_of_birth: `${1940 + Math.floor(Math.random() * 30)}-${String(Math.floor(Math.random() * 12) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`
        });
    }
    
    return users;
};

export const generateFakePatientAppointments = () => {
    const now = new Date();
    const appointments = [];
    const services = ['Personal Care', 'Meal Preparation', 'Medication Reminder', 'Companionship', 'Transportation'];
    const caregivers = ['Sarah Johnson', 'Michael Chen', 'Emily Rodriguez', 'David Kim', 'Lisa Thompson', 'James Wilson'];
    const statuses = ['Scheduled', 'Pending', 'Confirmed', 'Completed'];
    
    // Generate upcoming appointments (next 30 days)
    for (let i = 0; i < 15; i++) {
        const daysOffset = Math.floor(Math.random() * 30) + 1;
        const appointmentDate = new Date(now);
        appointmentDate.setDate(now.getDate() + daysOffset);
        
        const hour = 9 + Math.floor(Math.random() * 8);
        const minute = Math.random() < 0.5 ? 0 : 30;
        const startTime = new Date(appointmentDate);
        startTime.setHours(hour, minute, 0, 0);
        
        const endTime = new Date(startTime);
        endTime.setHours(startTime.getHours() + Math.floor(Math.random() * 3) + 1);
        
        appointments.push({
            appointment_id: `fake-apt-${i + 1}`,
            id: `fake-apt-${i + 1}`,
            start_date: startTime.toISOString(),
            end_date: endTime.toISOString(),
            caregiver: caregivers[Math.floor(Math.random() * caregivers.length)],
            service: services[Math.floor(Math.random() * services.length)],
            status: 'Scheduled',
            description: `Upcoming appointment for ${services[Math.floor(Math.random() * services.length)].toLowerCase()} services.`
        });
    }
    
    // Generate past appointments (last 30 days)
    for (let i = 0; i < 10; i++) {
        const daysOffset = Math.floor(Math.random() * 30);
        const appointmentDate = new Date(now);
        appointmentDate.setDate(now.getDate() - daysOffset);
        
        const hour = 9 + Math.floor(Math.random() * 8);
        const minute = Math.random() < 0.5 ? 0 : 30;
        const startTime = new Date(appointmentDate);
        startTime.setHours(hour, minute, 0, 0);
        
        const endTime = new Date(startTime);
        endTime.setHours(startTime.getHours() + Math.floor(Math.random() * 3) + 1);
        
        appointments.push({
            appointment_id: `fake-apt-${15 + i + 1}`,
            id: `fake-apt-${15 + i + 1}`,
            start_date: startTime.toISOString(),
            end_date: endTime.toISOString(),
            caregiver: caregivers[Math.floor(Math.random() * caregivers.length)],
            service: services[Math.floor(Math.random() * services.length)],
            status: statuses[Math.floor(Math.random() * statuses.length)],
            description: `Past appointment for ${services[Math.floor(Math.random() * services.length)].toLowerCase()} services.`
        });
    }
    
    return appointments.sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
};
